import { setSiteThemeColor } from "utils"
import * as types from "../types/systemSettings"
import { getPageDecorationTemplatesAccess, getSettings } from "services"

const setSiteMetaData = (response) => {
  document.getElementById("meta-tag-title").innerHTML =
    response.kitchenTitle

  document.getElementById("meta-tag-icon").href =
    `${response.kitchenLogo}?width=300`
}

export const fetchSystemSettings = () => (
  async (dispatch) => {
    try {
      const response = await getSettings()
      let pageDecorationTemplatesAccess = null

      try {
        pageDecorationTemplatesAccess =
          await getPageDecorationTemplatesAccess()
      } catch (err) {
        console.log(err)
      }

      setSiteMetaData(response)

      setSiteThemeColor(response.colorPalette)

      delete response.locationOptions

      dispatch({
        type: types.FETCH_SYSTEM_SETTINGS,
        data: {
          ...response,
          permittedPageDecorationTemplates:
            pageDecorationTemplatesAccess?.permittedPageDecorationTemplates ||
            response.permittedPageDecorationTemplates
        }
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const updateSystemSettings = (newSystemSettings) => ({
  type: types.UPDATE_SYSTEM_SETTINGS,
  newSystemSettings
})

export const setSystemClientName = (clientName) => ({
  type: types.SET_SYSTEM_CLIENTNAME,
  clientName
})

export const clearSystemSettings = (clientName) => ({
  type: types.CLEAR_SYSTEM_CLIENTNAME,
  clientName
})
